// Dimensions intrinsèques des logos partenaires — évite le décalage de mise
// en page (CLS) en donnant au navigateur le ratio d'aspect avant chargement.
export const LOGO_DIMS = {
  '/logo-partenaire/Affaires-mondiales-Canada.jpg': { width: 260, height: 173 },
  '/logo-partenaire/Government of New Brunswick.png': { width: 426, height: 118 },
  '/logo-partenaire/logo savoir sphere.png': { width: 332, height: 114 },
  '/logo-partenaire/CECI.png': { width: 350, height: 197 },
  '/logo-partenaire/logo_festic.png': { width: 500, height: 197 },
};
